<app-commentary-form-field
  *ngIf="postPermissions.add_comment"
  data-test-id="comment-form"
  [userAvatarVisibility]="true"
  [maxLength]="MAX_LENGTH"
  [counterVisibility]="true"
  [indexLabel]="'top'"
  [loadedComments]="loadedComments"
  [placeholderPhrases]="PLACEHOLDER_PHRASES"
  (sendTextMessage)="sendMessage({ message: $event, position: null })"
  (dirtyForm)="setFormStatus($event)"
></app-commentary-form-field>
<div *ngIf="loadedComments.rootCommentFullViews.length > 0">
  <div *ngFor="let rootCommentFullView of loadedComments.rootCommentFullViews; index as i">
    <ng-container *ngIf="rootCommentFullView.rootCommentView.source.permissions.view">
      <app-comment
        data-test-id="comments-pagination-"
        [commentView]="rootCommentFullView.rootCommentView"
        [commentPosition]="{ indexRoot: i }"
        [isCommentCreator]="isCommentCreator(rootCommentFullView.rootCommentView)"
        [isAdminSession]="isAdminSession"
        [loadedComments]="loadedComments"
        (sendMessage)="sendMessage($event, { indexRoot: i })"
        (removeComment)="onRemoveComment($event)"
        (dirtyForm)="setReplyFormStatus($event, { indexRoot: i })"
      ></app-comment>
      <div *ngFor="let replyCommentView of rootCommentFullView.replyCommentViews; index as k">
        <ng-container *ngIf="replyCommentView.source.permissions.view">
          <app-comment
            [commentView]="replyCommentView"
            [commentPosition]="{ indexRoot: i, indexReply: k }"
            [isCommentCreator]="isCommentCreator(replyCommentView)"
            [isAdminSession]="isAdminSession"
            [loadedComments]="loadedComments"
            (sendMessage)="sendMessage($event, { indexRoot: i, indexReply: k })"
            (removeComment)="onRemoveComment($event)"
            (dirtyForm)="setReplyFormStatus($event, { indexRoot: i, indexReply: k })"
          ></app-comment>
        </ng-container>
      </div>
      <ng-container *ngIf="needsReplyPagination(i)">
        <app-comments-pagination
          [attr.data-test-id]="'comments-pagination-' + i"
          [parentCommentPosition]="{ indexRoot: i }"
          (loadMore)="onLoadMoreComments($event)"
          (loadAll)="onLoadAllComments($event)"
        ></app-comments-pagination>
      </ng-container>
    </ng-container>
  </div>
  <ng-container *ngIf="needsRootPagination()">
    <app-comments-pagination
      [attr.data-test-id]="'comments-pagination-top'"
      [parentCommentPosition]="null"
      (loadMore)="onLoadMoreComments($event)"
      (loadAll)="onLoadAllComments($event)"
    ></app-comments-pagination>
  </ng-container>
</div>
